import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = ({ c }) => {
  const phone = c?.contact_phone || "066-7165071";
  const email = c?.contact_email || "mealsonwheelstralee@gmail.com";
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#8E1226] text-[#FBF7F0] pt-24 md:pt-32 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {c?.logo_image && (
          <img
            src={c.logo_image}
            alt="Meals on Wheels Tralee"
            data-testid="footer-logo"
            className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white object-cover mb-14 ring-1 ring-white/15"
          />
        )}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20 border-b border-[#FBF7F0]/15">
          <div className="md:col-span-5">
            <span className="text-xs uppercase tracking-[0.32em] text-[#0E6B3A]">
              {c?.footer_eyebrow || "Get in touch"}
            </span>
            <p className="mt-6 font-serif font-light text-3xl md:text-4xl leading-tight max-w-sm">
              {c?.footer_prompt}
            </p>
          </div>
          <div className="md:col-span-4 md:col-start-7 space-y-5 text-[#FBF7F0]/80">
            <a
              href={`tel:${phone.replace(/\s|-/g, "")}`}
              data-testid="footer-phone"
              className="flex items-center gap-3 hover:text-[#0E6B3A] transition-colors"
            >
              <Phone className="w-4 h-4" strokeWidth={1.6} /> {phone}
            </a>
            <a
              href={`mailto:${email}`}
              data-testid="footer-email"
              className="flex items-center gap-3 hover:text-[#0E6B3A] transition-colors break-all"
            >
              <Mail className="w-4 h-4 shrink-0" strokeWidth={1.6} /> {email}
            </a>
            <p className="flex items-start gap-3 leading-relaxed">
              <MapPin className="w-4 h-4 mt-1 shrink-0" strokeWidth={1.6} />
              {c?.contact_address}
            </p>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="py-14"
        >
          <div
            data-testid="footer-big"
            className="font-serif font-light leading-[0.85] tracking-tight whitespace-nowrap w-full"
            style={{ fontSize: "clamp(2.25rem, 9.2vw, 10rem)" }}
          >
            {c?.footer_big_text || "MEALS ON WHEELS"}
          </div>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-between gap-4 text-xs text-[#FBF7F0]/50 uppercase tracking-[0.2em]">
          <span>Registered Charity No. {c?.charity_no || "20158316"}</span>
          <span>Christmas Volunteer Sign-up · 2026</span>
        </div>
      </div>
    </footer>
  );
};
